import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import axios from 'axios'; // Import axios for API requests

// Components
import Navbar from '../navbar/Navbar';
import Loader from '../loader/Loader';
import SettingsSidebar from '../sidebar/SettingsSidebar';

// Action imports
import { updateProfile, getUser } from '../../actions/auth';

// CSS
import '../../css/landing/landing.css';
// import '../../css/profile/yourProfile.css';
import '../../css/userDetails/transactionHistory.css';

const TransactionHistory = ({
  auth: { isAuthenticated, user },
  getUser,
  updateProfile,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [transactionData, setTransactionData] = useState(null); // New state for transaction data

  // Fetch transaction history data when the component loads
  useEffect(() => {
    if (isAuthenticated && user) {
      axios
        .get(
          `${process.env.REACT_APP_API_URI}/ecomnext/api/transactions-detail`
        ) // Replace with actual API endpoint
        .then((response) => {
          setTransactionData(response.data.transactionDetails);
          setIsLoading(false); // Stop loading when data is fetched
        })
        .catch((error) => {
          toast.error('Failed to fetch transaction history');
          setIsLoading(false); // Stop loading in case of error
        });
    }
  }, [isAuthenticated, user]);

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className='flex min-h-screen'>
          {/* Sidebar */}
          <div className='w-64'>
            <SettingsSidebar />
          </div>

          {/* Main Content Area */}
          <div className='flex-1 flex flex-col'>
            {/* Navbar */}
            <div className=''>
              <Navbar />
            </div>

            {/* Main Content */}
            <div className='trnsc-history-page-wrapper flex-1 bg-white p-6'>
              {/* Heading and Horizontal Line */}
              <h1 className='trnsc-history-page-heading'>
                Transaction History
              </h1>
              <hr />

              {/* Transaction Table */}
              {/* Transaction Table */}
              {transactionData ? (
                <div className=''>
                  <table className='min-w-full table-auto bg-white shadow-lg rounded-lg mt-12'>
                    <thead className='bg-gray-100'>
                      <tr>
                        <th className='py-2 px-4 text-left text-sm font-medium text-gray-600'>
                          Transaction ID
                        </th>
                        <th className='py-2 px-4 text-left text-sm font-medium text-gray-600'>
                          Type
                        </th>
                        <th className='py-2 px-4 text-left text-sm font-medium text-gray-600'>
                          Description
                        </th>
                        <th className='py-2 px-4 text-left text-sm font-medium text-gray-600'>
                          Date
                        </th>
                        <th className='py-2 px-4 text-left text-sm font-medium text-gray-600'>
                          Payment Order ID
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {transactionData.map((transaction) => (
                        <tr
                          key={transaction.transaction_id}
                          className='border-t'
                        >
                          <td className='py-3 px-4 text-sm text-gray-700'>
                            {transaction.transaction_id}
                          </td>
                          <td className='py-3 px-4 text-sm text-gray-700'>
                            {transaction.transaction_type}
                          </td>
                          <td className='py-3 px-4 text-sm text-gray-700'>
                            {transaction.description}
                          </td>
                          <td className='py-3 px-4 text-sm text-gray-700'>
                            {new Date(
                              transaction.transaction_date
                            ).toLocaleString()}
                          </td>
                          <td className='py-3 px-4 text-sm text-gray-700'>
                            {transaction.razorpay_order_id}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p className='text-gray-500'>
                  No transaction history available
                </p>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { getUser, updateProfile })(
  TransactionHistory
);
